import { hash } from '@ember/helper';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview/index';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsActionComponent extends Component {
  // Defaults
  userDetailModes = [
    {
      value: 'basic',
      label: 'basic',
    },
    {
      value: 'mini',
      label: 'mini',
    },
    {
      value: 'medium',
      label: 'medium',
    },
  ];

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='headline' />

            <fieldset.field @property='text' @type='text-editor' />

            <fieldset.field
              @filters={{hash assetFolderId='2'}}
              @property='asset'
              @options={{hash allowedFolder='100'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
          </form.fieldset>

          <form.fieldset @titleKey='controls' as |fieldset|>
            <fieldset.field @property='aDateStart' @type='date' />
            <fieldset.field @property='aDateEnd' @type='date' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='artists'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsAdditive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExcluded'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExclusive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.fieldset @titleKey='connect' as |fieldset|>
            <fieldset.field @property='cgCompetitionId' />
            <fieldset.field
              @property='userDetailMode'
              @type='select-value'
              @options={{this.userDetailModes}}
            />
            <fieldset.field @property='wonText' @type='text-editor' />
            <fieldset.field @property='errorMessage' />
            <fieldset.field @property='thxMessage' />
            <fieldset.field @property='tosText' />
            <fieldset.field @property='smsText' />
            <fieldset.field @property='solicitableText' />
            <fieldset.field @property='questionaireText' />
            <fieldset.field @property='sharingText' />
            <fieldset.field @property='isContactForm' @type='checkbox' />
            <fieldset.field @property='contactFormRecipient' />
          </form.fieldset>

          <form.fieldset @titleKey='teaser' as |fieldset|>
            <fieldset.field @property='teaserHeadline' />
            <fieldset.field @property='teaserText' @type='text-editor' />

            <fieldset.field
              @filters={{hash assetFolderId='10'}}
              @property='assets'
              @options={{hash allowedFolder='100'}}
              @type='has-many'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
